<template>
  <div class="main-page" style="overflow:auto">
    <router-view></router-view>
    <notifications></notifications>

    <!-- Impersonate Mode Banner -->
    <div v-if="isImpersonating" class="impersonate-banner">
      <div class="impersonate-banner-content">
        <i class="fas fa-user-secret mr-2"></i>
        <span>{{ tt('impersonate_mode_active') }} <strong>{{ authUser ? authUser.name : '' }}</strong></span>
        <button class="btn btn-sm btn-light ml-3" @click="exitImpersonateMode" :disabled="exitLoading">
          <span v-if="exitLoading"><i class="fas fa-spinner fa-spin mr-1"></i></span>
          <span v-else><i class="fas fa-sign-out-alt mr-1"></i></span>
          {{ tt('exit_impersonate') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import Api from '@/helpers/api';
  import authService from '@/services/auth.service';

  export default {
    data() {
      return {
        isImpersonating: false,
        exitLoading: false
      }
    },
    computed: {
      ...mapState({
        authUser: state => state.auth.user
      })
    },
    watch: {
      '$route' (to, from) {
        if (to.name) {
          document.title = to.name+' - TOMS';
        } else {
          document.title = 'TOMS';
        }
        this.checkImpersonateMode();
      }
    },
    mounted() {
      this.checkImpersonateMode();
    },
    methods: {
      ...mapActions({
        authToken: 'auth/setToken',
        authAttemp: 'auth/attemp'
      }),
      checkImpersonateMode() {
        const mainToken = localStorage.getItem('main_token');
        this.isImpersonating = mainToken !== null && mainToken !== '';
      },
      exitImpersonateMode() {
        const mainToken = localStorage.getItem('main_token');
        if (mainToken) {
          this.exitLoading = true;
          this.authToken(mainToken);
          localStorage.removeItem('main_token');

          Api(this, authService.userProfile())
            .onSuccess((res) => {
              this.$notify({
                message: 'Successfully returned to original account',
                type: 'success',
                verticalAlign: 'bottom',
                horizontalAlign: 'left'
              });
              this.authAttemp(res.data.data.user);
              this.isImpersonating = false;
              this.$router.push('/manage/manage-account');
            })
            .onError(() => {
              localStorage.removeItem('token');
              this.$router.push('/login');
            })
            .onFinish(() => {
              this.exitLoading = false;
            })
            .call();
        }
      }
    }
  }
</script>

<style scoped>
.impersonate-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #f5365c 0%, #f56036 100%);
  color: white;
  padding: 12px 20px;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.impersonate-banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
}

.impersonate-banner i.fa-user-secret {
  font-size: 18px;
}

.impersonate-banner .btn-light {
  color: #f5365c;
  font-weight: 600;
}

.impersonate-banner .btn-light:hover {
  background-color: #fff;
  color: #f5365c;
}
</style>